import { getAcessToken } from "../Storage/Storage";

export const ApiHit = (json, api) => {
  return new Promise(function (resolve, reject) {
    const headers = { 'Content-Type': 'application/json' };
    var bearerToken = getAcessToken();
    if (bearerToken) {
      headers['Authorization'] = `Bearer ${bearerToken}`;
    }
    const requestPayload = {
      ...json,// Only add unitId if it exists
    };

    console.log("Request payload with unitId:", requestPayload);

    const requestOptions = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(requestPayload)
    };

    fetch(api, requestOptions)
      .then(res => res.json())
      .then(
        (result) => {
          console.log('result----', result);
          resolve(result);
        },
        (error) => {
          console.log('error----', error);
          reject(error);
        }
      ).catch((err) => {
        reject(err);
      })
  });
}

export const HitApiFormData = async (data, url, method = 'POST', additionalHeaders = {}) => {
  // Debug logging
  console.log('HitApiFormData called with:', { data, url, method });

  const formData = new FormData();

  // Append all data to FormData
  Object.entries(data).forEach(([key, value]) => {
    if (value instanceof File || value instanceof Blob) {
      formData.append(key, value, value.name || 'file');
    } else if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  try {
    const bearerToken = getAcessToken();
    const headers = {
      ...additionalHeaders,
    };

    // Add Authorization header if token exists
    if (bearerToken) {
      headers['Authorization'] = `Bearer ${bearerToken}`;
    }

    // Don't set Content-Type manually for FormData, let fetch handle it
    const httpMethod = String(method).toUpperCase();

    console.log('Making fetch request with method:', httpMethod);

    const response = await fetch(url, {
      method: httpMethod,
      headers: headers,
      body: formData,
    });

    const result = await response.json();

    console.log('HitApiFormData response:', result);

    return result;
  } catch (error) {
    console.error('HitApiFormData error:', error);
    throw error;
  }
};
